import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle-display-element"
export default class extends Controller {
  static targets = ["element", "checkbox"];
  static values = { display: String };

  declare elementTarget: HTMLElement;
  declare hasElementTarget: boolean;
  declare checkboxTargets: HTMLInputElement[];
  declare hasCheckboxTarget: boolean;
  declare displayValue: string;
  declare hasDisplayValue: boolean;

  connect() {
    if (this.hasCheckboxTarget) {
      this.toggle();
    }
  }

  toggle() {
    // element hidden si aucune checkbox/radio cochée
    if (this.hasCheckboxTarget && this.hasElementTarget) {
      if (this.checkboxTargets.some((cb) => cb.checked && (!this.hasDisplayValue || cb.value == this.displayValue))) {
        this.elementTarget.classList.remove("hidden");
      } else {
        this.elementTarget.classList.add("hidden");
      }
      // toggle hidden si l'élément cible est trouvé
    } else if (this.hasElementTarget) {
      this.elementTarget.classList.toggle("hidden");
    }
  }
}
